import moment from 'moment';
import { FieldTypes } from '../helpers/constants';
import { getQuerystringParameters } from '../helpers/utility';
import { getValue } from './selectors';
import { getEditableValue } from './helpers';
import { convertFieldFormatToMoment } from '../helpers/DateTimeUtility';
import { getDropDownItems } from './components/ListView/Fields/DropDownField';
import { ValueChangedFunc } from './formeditor-types';
import { ItemCollection, Template, TemplateField } from '../types/template-types';
import { Form } from '../types/form-types';

const ignoredParams = ['id', 'fid'];

export function handleUrlParameterValues(
  template: Template,
  form: Form,
  userId: string,
  isAdmin: boolean,
  valueChanged: ValueChangedFunc,
  itemCollections: any[]
): void {
  const queryParams = getQuerystringParameters(true);
  const fields = template.fields;

  for (const queryParam in queryParams) {
    // eslint-disable-next-line no-prototype-builtins
    if (queryParams.hasOwnProperty(queryParam) && ignoredParams.indexOf(queryParams) === -1) {
      try {
        // todo - move this logic into a shared helper since it's now used in hipaa and potentially other
        //        places
        const field = fields.find((x) => x.name.toLowerCase() === decodeURIComponent(queryParam));
        if (field) {
          const fieldValue = getValue(form, field.id);
          const currentValue = (fieldValue ? fieldValue.value : '') || '';
          const editable = getEditableValue(form, field, currentValue, userId, isAdmin);
          if (editable) {
            const value = decodeURIComponent(queryParams[queryParam]) || '';
            validateValueAndSendToCalc(value, field, valueChanged, itemCollections);
          } else {
            console.warn(`Attempting to update non-editable field: ${field.name}`);
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
}

function validateValueAndSendToCalc(value: string, field: TemplateField, valueChanged: ValueChangedFunc, itemCollections: ItemCollection[]): void {
  const fieldType = field.type;

  if (fieldType === FieldTypes.Date || fieldType === FieldTypes.DateTime || fieldType === FieldTypes.Time) {
    const dateFormat = convertFieldFormatToMoment(field.dateTimeFormat);
    let parsedDate = moment(value, dateFormat);
    // if we can't parse it, let's try without our format
    if (!parsedDate.isValid()) {
      parsedDate = moment(value);
    }
    if (parsedDate.isValid()) {
      valueChanged({ value: parsedDate.format(dateFormat) }, field);
    }
  } else if (fieldType === FieldTypes.CheckBox) {
    if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
      valueChanged({ value: value.toLowerCase() }, field);
    }
  } else if (fieldType === FieldTypes.Number) {
    if (value.match(/^[0-9,!@#$%^&*()_+:;<>?/=\-.]+$/)) {
      valueChanged({ value: value }, field);
    }
  } else if (fieldType === FieldTypes.Barcode || fieldType === FieldTypes.TextArea || fieldType === FieldTypes.TextBox || fieldType === FieldTypes.Database) {
    valueChanged({ value: value }, field);
  } else if (fieldType === FieldTypes.DropDown) {
    const dropDownItems = getDropDownItems(field.items, itemCollections, field.itemCollectionTemplateId);
    let matchingItem = dropDownItems.find((x) => x.value.toLowerCase() === value.toLowerCase());
    if (!matchingItem) {
      matchingItem = dropDownItems.find((x) => x.displayName.toLowerCase() === value.toLowerCase());
    }
    if (matchingItem) {
      valueChanged(matchingItem.value, field);
    } else if (field.allowOther) {
      valueChanged({ value: value }, field);
    }
  } else if (fieldType === FieldTypes.CheckBoxGroup) {
    const checkBoxItems = field.items;

    const values = field.multiSelect ? value.split(';') : [value];
    const matchingItems = [];
    for (const v of values) {
      let matchingItem = checkBoxItems.find((x) => x.value.toLowerCase() === v.toLowerCase());
      if (!matchingItem) {
        matchingItem = checkBoxItems.find((x) => x.displayName.toLowerCase() === v.toLowerCase());
      }
      if (matchingItem) {
        matchingItems.push(matchingItem);
      }
    }

    if (matchingItems.length > 0) {
      valueChanged({ value: matchingItems.map((matchingItem) => matchingItem.value).join(';') }, field);
    }
  }
}
